class VelioPackOptionPicker extends HTMLElement {
  connectedCallback() {
    if (this._connected) return;
    this._connected = true;
    const picker = this.closest('quantity-breaks-picker');
    const rulesElement = picker?.querySelector('[data-quantity-rules]');
    if (!rulesElement) return;
    try { this._rules = JSON.parse(rulesElement.textContent); } catch { return; }
    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-pack-option]')) return;
      this._resolveRow(event.target.closest('[data-pack-option-row]'));
    });
    this.querySelectorAll('[data-pack-option-row]').forEach((row) => this._resolveRow(row));
  }

  _resolveRow(row) {
    if (!row) return;
    const options = [...row.querySelectorAll('[data-pack-option]')];
    const variantInput = row.querySelector('[data-pack-variant]');
    if (!options.length || !variantInput) return;
    const selected = Object.fromEntries(options.map((select) => [select.dataset.optionPosition, select.value]));
    const match = Object.entries(this._rules).find(([, rule]) => [1, 2, 3].every((position) => {
      const key = 'option' + position;
      const selectedValue = selected[String(position)] ?? row.dataset['fixedOption' + position] ?? '';
      return String(rule[key] ?? '') === String(selectedValue);
    }));
    const nextId = match ? match[0] : '';
    if (variantInput.value !== nextId) {
      variantInput.value = nextId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    row.dataset.variantValid = String(Boolean(match && match[1].available));
    row.setAttribute('aria-invalid', String(!match || !match[1].available));
  }
}

if (!customElements.get('velio-pack-option-picker')) {
  customElements.define('velio-pack-option-picker', VelioPackOptionPicker);
}
